<script setup>
import CustomFieldValue from "@/components/customFields/CustomFieldValue.vue";
import {onMounted, ref} from "vue";
import trackersPublicService from "@/services/trackers-public.service";

const props = defineProps(['trackerId']);

const answers = ref([]);

onMounted(() => {
    getAnswers();
});
async function getAnswers() {
    const {data} = await trackersPublicService.getAnswers(props.trackerId);

    answers.value = data;
}
</script>

<template>
    <div>
        <div v-for="(answer, index) in answers" :key="index" class="mt-2 mb-4">
            <h5 class="heading5 heading5--secondary">{{answer.field.name}}</h5>

            <CustomFieldValue
                :field="answer.field"
                :init-value="answer.value"
                :editable="false"
            />
        </div>
    </div>
</template>

<style scoped>

</style>
